export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14617.24a3e776.jpg";